// 从 lucide-react 导入所有图标类型
import iconNodes from 'lucide-static/icon-nodes.json'

// 创建 lucide 图标名称的类型
type LucideIconName = keyof typeof iconNodes

export interface IconData {
  name: LucideIconName
  keywords: string[]
}

// Available icons with their metadata
export const AVAILABLE_ICONS: IconData[] = [
  {
    name: 'sparkles',
    keywords: ['magic', 'star', 'shine', 'effect'],
  },
  {
    name: 'heart',
    keywords: ['love', 'like', 'favorite'],
  },
  {
    name: 'star',
    keywords: ['favorite', 'rating', 'bookmark'],
  },
  {
    name: 'house',
    keywords: ['house', 'main', 'dashboard'],
  },
  {
    name: 'user',
    keywords: ['person', 'profile', 'account'],
  },
  {
    name: 'settings',
    keywords: ['config', 'gear', 'options'],
  },
  {
    name: 'mail',
    keywords: ['email', 'message', 'contact'],
  },
  {
    name: 'phone',
    keywords: ['call', 'contact', 'mobile'],
  },
  {
    name: 'calendar',
    keywords: ['date', 'schedule', 'event'],
  },
  {
    name: 'clock',
    keywords: ['time', 'schedule', 'timer'],
  },
  {
    name: 'map-pin',
    keywords: ['location', 'place', 'address'],
  },
  {
    name: 'camera',
    keywords: ['photo', 'picture', 'capture'],
  },
  {
    name: 'image',
    keywords: ['photo', 'picture', 'media'],
  },
  {
    name: 'file',
    keywords: ['document', 'text', 'paper'],
  },
  {
    name: 'download',
    keywords: ['save', 'get', 'import'],
  },
  {
    name: 'upload',
    keywords: ['send', 'export', 'share'],
  },
  {
    name: 'square-pen',
    keywords: ['pencil', 'modify', 'change'],
  },
  {
    name: 'trash',
    keywords: ['delete', 'remove', 'bin'],
  },
  {
    name: 'plus',
    keywords: ['add', 'create', 'new'],
  },
  {
    name: 'minus',
    keywords: ['remove', 'subtract', 'less'],
  },
  {
    name: 'check',
    keywords: ['done', 'complete', 'success'],
  },
  {
    name: 'circle-check-big',
    keywords: ['done', 'complete', 'verified', 'pass', 'test-result'],
  },
  {
    name: 'x',
    keywords: ['close', 'cancel', 'remove'],
  },
  {
    name: 'chevron-right',
    keywords: ['next', 'expand', 'more'],
  },
  {
    name: 'chevron-left',
    keywords: ['back', 'collapse', 'less'],
  },
  {
    name: 'chevron-up',
    keywords: ['up', 'collapse', 'less'],
  },
  {
    name: 'chevron-down',
    keywords: ['down', 'expand', 'more'],
  },
  {
    name: 'play',
    keywords: ['start', 'begin', 'media'],
  },
  {
    name: 'pause',
    keywords: ['stop', 'wait', 'media'],
  },
  {
    name: 'square',
    keywords: ['stop', 'end', 'finish', 'media'],
  },
  {
    name: 'volume',
    keywords: ['sound', 'audio', 'speaker'],
  },
  {
    name: 'wifi',
    keywords: ['internet', 'connection', 'network'],
  },
  {
    name: 'sun',
    keywords: ['light', 'day', 'bright'],
  },
  {
    name: 'moon',
    keywords: ['dark', 'night', 'theme'],
  },
  {
    name: 'cloud',
    keywords: ['weather', 'storage', 'online'],
  },
  {
    name: 'zap',
    keywords: ['lightning', 'fast', 'energy'],
  },
  {
    name: 'shield',
    keywords: ['security', 'protection', 'safe'],
  },
  {
    name: 'shield-check',
    keywords: ['security', 'verified', 'compliance', 'audit', 'soc2'],
  },
  {
    name: 'lock',
    keywords: ['secure', 'private', 'protected'],
  },
  {
    name: 'lock-open',
    keywords: ['open', 'access', 'available'],
  },
  {
    name: 'eye',
    keywords: ['view', 'see', 'visible'],
  },
  {
    name: 'eye-off',
    keywords: ['hide', 'invisible', 'private'],
  },
  {
    name: 'bell',
    keywords: ['notification', 'alert', 'reminder'],
  },
  {
    name: 'bell-off',
    keywords: ['silent', 'mute', 'no-notification'],
  },
  {
    name: 'bookmark',
    keywords: ['save', 'mark', 'favorite'],
  },
  {
    name: 'tag',
    keywords: ['label', 'category', 'mark'],
  },
  {
    name: 'flag',
    keywords: ['marker', 'important', 'report'],
  },
  {
    name: 'target',
    keywords: ['goal', 'aim', 'focus'],
  },
  {
    name: 'trending-up',
    keywords: ['growth', 'increase', 'success'],
  },
  {
    name: 'activity',
    keywords: ['pulse', 'heart', 'health'],
  },
  {
    name: 'chart-pie',
    keywords: ['chart', 'data', 'statistics'],
  },
  {
    name: 'smile',
    keywords: ['face', 'happy', 'emotion'],
  },
  {
    name: 'lightbulb',
    keywords: ['idea', 'innovation', 'think'],
  },
  {
    name: 'coffee',
    keywords: ['drink', 'break', 'energy'],
  },
  {
    name: 'gift',
    keywords: ['present', 'reward', 'surprise'],
  },
  {
    name: 'palette',
    keywords: ['color', 'art', 'design'],
  },
  {
    name: 'shuffle',
    keywords: ['random', 'mix', 'change'],
  },
  {
    name: 'users',
    keywords: ['group', 'team', 'people'],
  },
  {
    name: 'circle-check-big',
    keywords: ['success', 'complete', 'ok'],
  },
  {
    name: 'pencil',
    keywords: ['pencil', 'write', 'change'],
  },
  {
    name: 'trash-2',
    keywords: ['delete', 'remove', 'bin'],
  },
  {
    name: 'search',
    keywords: ['find', 'magnifier', 'lookup'],
  },
  {
    name: 'arrow-up',
    keywords: ['direction', 'top', 'move'],
  },
  {
    name: 'arrow-down',
    keywords: ['direction', 'bottom', 'move'],
  },
  {
    name: 'arrow-left',
    keywords: ['direction', 'previous', 'back'],
  },
  {
    name: 'arrow-right',
    keywords: ['direction', 'next', 'forward'],
  },
  {
    name: 'globe',
    keywords: ['world', 'internet', 'web'],
  },
  {
    name: 'map',
    keywords: ['location', 'place', 'navigation'],
  },
  {
    name: 'message-circle',
    keywords: ['chat', 'comment', 'talk'],
  },
  {
    name: 'info',
    keywords: ['information', 'details', 'about'],
  },
  {
    name: 'triangle-alert',
    keywords: ['warning', 'caution', 'danger'],
  },
  {
    name: 'circle-alert',
    keywords: ['warning', 'error', 'attention'],
  },
  {
    name: 'clipboard',
    keywords: ['copy', 'paste', 'note'],
  },
  {
    name: 'list',
    keywords: ['items', 'bullets', 'tasks'],
  },
  {
    name: 'menu',
    keywords: ['navigation', 'bars', 'hamburger'],
  },
  {
    name: 'external-link',
    keywords: ['open', 'new', 'window'],
  },
  {
    name: 'link',
    keywords: ['url', 'chain', 'connect'],
  },
  {
    name: 'paperclip',
    keywords: ['attach', 'file', 'clip'],
  },
  {
    name: 'credit-card',
    keywords: ['payment', 'money', 'purchase'],
  },
  {
    name: 'shopping-cart',
    keywords: ['buy', 'ecommerce', 'basket'],
  },
  {
    name: 'truck',
    keywords: ['delivery', 'shipping', 'transport'],
  },
  {
    name: 'trophy',
    keywords: ['award', 'win', 'achievement'],
  },
  {
    name: 'medal',
    keywords: ['award', 'prize', 'achievement'],
  },
  {
    name: 'feather',
    keywords: ['write', 'light', 'pen'],
  },
  {
    name: 'book',
    keywords: ['read', 'library', 'education'],
  },
  {
    name: 'graduation-cap',
    keywords: ['education', 'school', 'study'],
  },
  {
    name: 'music',
    keywords: ['audio', 'song', 'note'],
  },
  {
    name: 'film',
    keywords: ['movie', 'video', 'media'],
  },
  {
    name: 'tv',
    keywords: ['screen', 'display', 'media'],
  },
  {
    name: 'gamepad',
    keywords: ['play', 'controller', 'gaming'],
  },
  {
    name: 'cpu',
    keywords: ['computer', 'processor', 'hardware'],
  },
  {
    name: 'server',
    keywords: ['database', 'cloud', 'network'],
  },
  {
    name: 'database',
    keywords: ['storage', 'data', 'server'],
  },
  {
    name: 'code',
    keywords: ['program', 'developer', 'brackets'],
  },
  {
    name: 'terminal',
    keywords: ['command', 'console', 'shell'],
  },
  {
    name: 'bug',
    keywords: ['error', 'issue', 'problem'],
  },
  {
    name: 'rocket',
    keywords: ['launch', 'startup', 'space'],
  },
  {
    name: 'star-half',
    keywords: ['rate', 'favorite', 'half'],
  },
  {
    name: 'star-off',
    keywords: ['unfavorite', 'remove', 'star'],
  },
  {
    name: 'refresh-ccw',
    keywords: ['reload', 'sync', 'update'],
  },
  {
    name: 'refresh-cw',
    keywords: ['reload', 'sync', 'update'],
  },
  {
    name: 'repeat',
    keywords: ['loop', 'cycle', 'again'],
  },
  {
    name: 'undo',
    keywords: ['back', 'reverse', 'previous'],
  },
  {
    name: 'funnel-plus',
    keywords: ['sort', 'search', 'refine'],
  },
  {
    name: 'sliders-vertical',
    keywords: ['settings', 'controls', 'adjust'],
  },
  {
    name: 'volume-2',
    keywords: ['sound', 'audio', 'speaker'],
  },
  {
    name: 'volume-x',
    keywords: ['mute', 'silent', 'audio'],
  },
  {
    name: 'mic',
    keywords: ['record', 'audio', 'voice'],
  },
  {
    name: 'mic-off',
    keywords: ['mute', 'audio', 'off'],
  },
  {
    name: 'sunrise',
    keywords: ['morning', 'day', 'light'],
  },
  {
    name: 'sunset',
    keywords: ['evening', 'night', 'light'],
  },
  {
    name: 'thermometer',
    keywords: ['temperature', 'heat', 'cold'],
  },
  {
    name: 'umbrella',
    keywords: ['rain', 'weather', 'protection'],
  },
  {
    name: 'droplet',
    keywords: ['water', 'liquid', 'drop'],
  },
  {
    name: 'leaf',
    keywords: ['nature', 'eco', 'plant'],
  },
  {
    name: 'tree-deciduous',
    keywords: ['nature', 'plant', 'forest'],
  },
  {
    name: 'flower',
    keywords: ['nature', 'plant', 'bloom'],
  },
  {
    name: 'mountain',
    keywords: ['nature', 'hill', 'peak'],
  },
  {
    name: 'anchor',
    keywords: ['boat', 'hold', 'stable'],
  },
  {
    name: 'compass',
    keywords: ['navigation', 'direction', 'map'],
  },
  {
    name: 'glasses',
    keywords: ['see', 'vision', 'read'],
  },
  {
    name: 'watch',
    keywords: ['time', 'clock', 'wrist'],
  },
  {
    name: 'wallet',
    keywords: ['money', 'payment', 'finance'],
  },
  {
    name: 'shopping-bag',
    keywords: ['buy', 'ecommerce', 'store'],
  },
  {
    name: 'hand',
    keywords: ['gesture', 'stop', 'palm'],
  },
  {
    name: 'thumbs-up',
    keywords: ['like', 'approve', 'good'],
  },
  {
    name: 'thumbs-down',
    keywords: ['dislike', 'disapprove', 'bad'],
  },
  {
    name: 'frown',
    keywords: ['sad', 'face', 'emotion'],
  },
  {
    name: 'meh',
    keywords: ['neutral', 'face', 'emotion'],
  },
  {
    name: 'airplay',
    keywords: ['cast', 'stream', 'display'],
  },
  {
    name: 'alarm-clock',
    keywords: ['clock', 'time', 'alert'],
  },
  {
    name: 'alarm-clock-off',
    keywords: ['clock', 'off', 'alert'],
  },
  {
    name: 'album',
    keywords: ['music', 'collection', 'photos'],
  },
  {
    name: 'align-justify',
    keywords: ['text', 'format', 'justify'],
  },
  {
    name: 'aperture',
    keywords: ['camera', 'photo', 'lens'],
  },
  {
    name: 'app-window',
    keywords: ['application', 'window', 'ui'],
  },
  {
    name: 'apple',
    keywords: ['fruit', 'food', 'mac'],
  },
  {
    name: 'archive',
    keywords: ['box', 'storage', 'save'],
  },
  {
    name: 'archive-restore',
    keywords: ['box', 'restore', 'save'],
  },
  {
    name: 'armchair',
    keywords: ['furniture', 'seat', 'chair'],
  },
  {
    name: 'arrow-big-down',
    keywords: ['arrow', 'down', 'large'],
  },
  {
    name: 'arrow-big-left',
    keywords: ['arrow', 'left', 'large'],
  },
  {
    name: 'arrow-big-right',
    keywords: ['arrow', 'right', 'large'],
  },
  {
    name: 'arrow-big-up',
    keywords: ['arrow', 'up', 'large'],
  },
  {
    name: 'circle-arrow-down',
    keywords: ['arrow', 'down', 'circle'],
  },
  {
    name: 'arrow-down-left',
    keywords: ['arrow', 'down', 'left'],
  },
  {
    name: 'arrow-down-right',
    keywords: ['arrow', 'down', 'right'],
  },
  {
    name: 'circle-arrow-left',
    keywords: ['arrow', 'left', 'circle'],
  },
  {
    name: 'circle-arrow-right',
    keywords: ['arrow', 'right', 'circle'],
  },
  {
    name: 'circle-arrow-up',
    keywords: ['arrow', 'up', 'circle'],
  },
  {
    name: 'arrow-up-left',
    keywords: ['arrow', 'up', 'left'],
  },
  {
    name: 'arrow-up-right',
    keywords: ['arrow', 'up', 'right'],
  },
  {
    name: 'asterisk',
    keywords: ['star', 'symbol', 'wildcard'],
  },
  {
    name: 'at-sign',
    keywords: ['email', 'address', 'symbol'],
  },
  {
    name: 'atom',
    keywords: ['science', 'physics', 'molecule'],
  },
  {
    name: 'award',
    keywords: ['prize', 'badge', 'achievement'],
  },
  {
    name: 'axe',
    keywords: ['tool', 'chop', 'wood'],
  },
  {
    name: 'baby',
    keywords: ['child', 'infant', 'kid'],
  },
  {
    name: 'backpack',
    keywords: ['bag', 'travel', 'school'],
  },
  {
    name: 'badge',
    keywords: ['award', 'prize', 'achievement'],
  },
  {
    name: 'badge-alert',
    keywords: ['award', 'alert', 'notification'],
  },
  {
    name: 'badge-check',
    keywords: ['award', 'check', 'verified'],
  },
  {
    name: 'badge-dollar-sign',
    keywords: ['award', 'money', 'finance'],
  },
  {
    name: 'badge-info',
    keywords: ['award', 'info', 'information'],
  },
  {
    name: 'badge-minus',
    keywords: ['award', 'minus', 'remove'],
  },
  {
    name: 'badge-percent',
    keywords: ['award', 'percent', 'discount'],
  },
  {
    name: 'badge-plus',
    keywords: ['award', 'plus', 'add'],
  },
  {
    name: 'badge-x',
    keywords: ['award', 'x', 'remove'],
  },
  {
    name: 'baggage-claim',
    keywords: ['airport', 'luggage', 'travel'],
  },
  {
    name: 'ban',
    keywords: ['block', 'forbidden', 'stop'],
  },
  {
    name: 'banana',
    keywords: ['fruit', 'food', 'yellow'],
  },
  {
    name: 'banknote',
    keywords: ['money', 'finance', 'currency'],
  },
  {
    name: 'chart-bar',
    keywords: ['graph', 'analytics', 'data'],
  },
  {
    name: 'chart-column-increasing',
    keywords: ['graph', 'analytics', 'data'],
  },
  {
    name: 'chart-bar-big',
    keywords: ['graph', 'analytics', 'data'],
  },
  {
    name: 'barcode',
    keywords: ['scan', 'product', 'code'],
  },
  {
    name: 'baseline',
    keywords: ['text', 'align', 'line'],
  },
  {
    name: 'bath',
    keywords: ['tub', 'water', 'clean'],
  },
  {
    name: 'battery',
    keywords: ['power', 'charge', 'energy'],
  },
  {
    name: 'battery-charging',
    keywords: ['power', 'charge', 'energy'],
  },
  {
    name: 'battery-full',
    keywords: ['power', 'charge', 'energy'],
  },
  {
    name: 'battery-low',
    keywords: ['power', 'charge', 'energy'],
  },
  {
    name: 'battery-medium',
    keywords: ['power', 'charge', 'energy'],
  },
  {
    name: 'beaker',
    keywords: ['science', 'lab', 'chemistry'],
  },
  {
    name: 'bean',
    keywords: ['food', 'plant', 'vegetable'],
  },
  {
    name: 'bean-off',
    keywords: ['food', 'plant', 'vegetable'],
  },
  {
    name: 'bed',
    keywords: ['sleep', 'rest', 'furniture'],
  },
  {
    name: 'bed-double',
    keywords: ['sleep', 'rest', 'furniture'],
  },
  {
    name: 'bed-single',
    keywords: ['sleep', 'rest', 'furniture'],
  },
  {
    name: 'beer',
    keywords: ['drink', 'alcohol', 'bar'],
  },
  {
    name: 'bell-dot',
    keywords: ['notification', 'alert', 'dot'],
  },
  {
    name: 'bell-minus',
    keywords: ['notification', 'alert', 'remove'],
  },
  {
    name: 'bell-plus',
    keywords: ['notification', 'alert', 'add'],
  },
  {
    name: 'bell-ring',
    keywords: ['notification', 'alert', 'sound'],
  },
  {
    name: 'bike',
    keywords: ['bicycle', 'transport', 'ride'],
  },
  {
    name: 'binary',
    keywords: ['code', 'programming', 'data'],
  },
  {
    name: 'biohazard',
    keywords: ['danger', 'hazard', 'warning'],
  },
  {
    name: 'bird',
    keywords: ['animal', 'fly', 'nature'],
  },
  {
    name: 'bluetooth',
    keywords: ['wireless', 'connection', 'device'],
  },
  {
    name: 'bluetooth-connected',
    keywords: ['wireless', 'connection', 'device'],
  },
  {
    name: 'bluetooth-off',
    keywords: ['wireless', 'connection', 'device'],
  },
  {
    name: 'bluetooth-searching',
    keywords: ['wireless', 'connection', 'device'],
  },
  {
    name: 'bold',
    keywords: ['text', 'format', 'strong'],
  },
  {
    name: 'bomb',
    keywords: ['explosion', 'danger', 'weapon'],
  },
  {
    name: 'bone',
    keywords: ['skeleton', 'animal', 'dog'],
  },
  {
    name: 'book-a',
    keywords: ['read', 'library', 'education'],
  },
  {
    name: 'book-audio',
    keywords: ['read', 'audio', 'education'],
  },
  {
    name: 'book-check',
    keywords: ['read', 'library', 'check'],
  },
  {
    name: 'book-copy',
    keywords: ['read', 'library', 'copy'],
  },
  {
    name: 'book-down',
    keywords: ['read', 'library', 'down'],
  },
  {
    name: 'book-headphones',
    keywords: ['read', 'audio', 'education'],
  },
  {
    name: 'book-heart',
    keywords: ['read', 'library', 'love'],
  },
  {
    name: 'book-image',
    keywords: ['read', 'library', 'image'],
  },
  {
    name: 'book-key',
    keywords: ['read', 'library', 'key'],
  },
  {
    name: 'book-lock',
    keywords: ['read', 'library', 'lock'],
  },
  {
    name: 'book-marked',
    keywords: ['read', 'library', 'bookmark'],
  },
  {
    name: 'book-minus',
    keywords: ['read', 'library', 'remove'],
  },
  {
    name: 'book-open',
    keywords: ['read', 'library', 'open'],
  },
  {
    name: 'book-plus',
    keywords: ['read', 'library', 'add'],
  },
  {
    name: 'book-text',
    keywords: ['read', 'library', 'text'],
  },
  {
    name: 'book-type',
    keywords: ['read', 'library', 'type'],
  },
  {
    name: 'book-up',
    keywords: ['read', 'library', 'up'],
  },
  {
    name: 'book-user',
    keywords: ['read', 'library', 'user'],
  },
  {
    name: 'book-x',
    keywords: ['read', 'library', 'remove'],
  },
  {
    name: 'bookmark-minus',
    keywords: ['save', 'favorite', 'remove'],
  },
  {
    name: 'bookmark-plus',
    keywords: ['save', 'favorite', 'add'],
  },
  {
    name: 'bookmark-x',
    keywords: ['save', 'favorite', 'remove'],
  },
  {
    name: 'bot',
    keywords: ['robot', 'ai', 'automation'],
  },
  {
    name: 'box',
    keywords: ['package', 'container', 'storage'],
  },
  {
    name: 'boxes',
    keywords: ['package', 'container', 'storage'],
  },
  {
    name: 'braces',
    keywords: ['code', 'programming', 'brackets'],
  },
  {
    name: 'brackets',
    keywords: ['code', 'programming', 'brackets'],
  },
  {
    name: 'brain',
    keywords: ['mind', 'intelligence', 'science'],
  },
  {
    name: 'briefcase',
    keywords: ['work', 'business', 'case'],
  },
  {
    name: 'brush',
    keywords: ['paint', 'art', 'draw'],
  },
  {
    name: 'bug-off',
    keywords: ['error', 'issue', 'problem'],
  },
  {
    name: 'building',
    keywords: ['office', 'city', 'architecture'],
  },
  {
    name: 'bus',
    keywords: ['transport', 'vehicle', 'travel'],
  },
  {
    name: 'cake',
    keywords: ['dessert', 'birthday', 'food'],
  },
  {
    name: 'calculator',
    keywords: ['math', 'arithmetic', 'count'],
  },
  {
    name: 'calendar-check',
    keywords: ['date', 'event', 'check'],
  },
  {
    name: 'calendar-clock',
    keywords: ['date', 'event', 'time'],
  },
  {
    name: 'calendar-days',
    keywords: ['date', 'event', 'days'],
  },
  {
    name: 'calendar-heart',
    keywords: ['date', 'event', 'love'],
  },
  {
    name: 'calendar-minus',
    keywords: ['date', 'event', 'remove'],
  },
  {
    name: 'calendar-off',
    keywords: ['date', 'event', 'off'],
  },
  {
    name: 'calendar-plus',
    keywords: ['date', 'event', 'add'],
  },
  {
    name: 'calendar-range',
    keywords: ['date', 'event', 'range'],
  },
  {
    name: 'calendar-search',
    keywords: ['date', 'event', 'search'],
  },
  {
    name: 'calendar-x',
    keywords: ['date', 'event', 'remove'],
  },
  {
    name: 'camera-off',
    keywords: ['photo', 'picture', 'off'],
  },
  {
    name: 'car',
    keywords: ['vehicle', 'transport', 'drive'],
  },
  {
    name: 'carrot',
    keywords: ['food', 'vegetable', 'orange'],
  },
  {
    name: 'cast',
    keywords: ['stream', 'display', 'airplay'],
  },
  {
    name: 'castle',
    keywords: ['building', 'fortress', 'history'],
  },
  {
    name: 'cat',
    keywords: ['animal', 'pet', 'feline'],
  },
  {
    name: 'chevron-first',
    keywords: ['arrow', 'first', 'direction'],
  },
  {
    name: 'chevron-last',
    keywords: ['arrow', 'last', 'direction'],
  },
  {
    name: 'chevrons-down',
    keywords: ['arrow', 'down', 'double'],
  },
  {
    name: 'chevrons-left',
    keywords: ['arrow', 'left', 'double'],
  },
  {
    name: 'chevrons-right',
    keywords: ['arrow', 'right', 'double'],
  },
  {
    name: 'chevrons-up',
    keywords: ['arrow', 'up', 'double'],
  },
  {
    name: 'chrome',
    keywords: ['browser', 'web', 'google'],
  },
  {
    name: 'circle',
    keywords: ['shape', 'geometry', 'round'],
  },
  {
    name: 'circle-dot',
    keywords: ['shape', 'geometry', 'dot'],
  },
  {
    name: 'circle-slash',
    keywords: ['shape', 'geometry', 'forbidden'],
  },
  {
    name: 'clipboard-check',
    keywords: ['copy', 'paste', 'check'],
  },
  {
    name: 'clipboard-copy',
    keywords: ['copy', 'paste', 'document'],
  },
  {
    name: 'clipboard-list',
    keywords: ['copy', 'paste', 'list'],
  },
  {
    name: 'clipboard-minus',
    keywords: ['copy', 'paste', 'remove'],
  },
  {
    name: 'clipboard-plus',
    keywords: ['copy', 'paste', 'add'],
  },
  {
    name: 'clipboard-x',
    keywords: ['copy', 'paste', 'remove'],
  },
  {
    name: 'cloud-drizzle',
    keywords: ['weather', 'rain', 'sky'],
  },
  {
    name: 'cloud-fog',
    keywords: ['weather', 'fog', 'sky'],
  },
  {
    name: 'cloud-hail',
    keywords: ['weather', 'hail', 'sky'],
  },
  {
    name: 'cloud-lightning',
    keywords: ['weather', 'lightning', 'sky'],
  },
  {
    name: 'cloud-moon',
    keywords: ['weather', 'night', 'sky'],
  },
  {
    name: 'cloud-off',
    keywords: ['weather', 'off', 'sky'],
  },
  {
    name: 'cloud-rain',
    keywords: ['weather', 'rain', 'sky'],
  },
  {
    name: 'cloud-snow',
    keywords: ['weather', 'snow', 'sky'],
  },
  {
    name: 'cloud-sun',
    keywords: ['weather', 'day', 'sky'],
  },
  {
    name: 'cloudy',
    keywords: ['weather', 'cloud', 'sky'],
  },
  {
    name: 'clover',
    keywords: ['plant', 'nature', 'luck'],
  },
  {
    name: 'codepen',
    keywords: ['web', 'developer', 'code'],
  },
  {
    name: 'codesandbox',
    keywords: ['web', 'developer', 'code'],
  },
  {
    name: 'cog',
    keywords: ['settings', 'gear', 'preferences'],
  },
  {
    name: 'coins',
    keywords: ['money', 'finance', 'currency'],
  },
  {
    name: 'columns-3',
    keywords: ['layout', 'grid', 'design'],
  },
  {
    name: 'command',
    keywords: ['keyboard', 'mac', 'shortcut'],
  },
  {
    name: 'component',
    keywords: ['ui', 'element', 'part'],
  },
  {
    name: 'concierge-bell',
    keywords: ['service', 'hotel', 'bell'],
  },
  {
    name: 'contact',
    keywords: ['person', 'address', 'info'],
  },
  {
    name: 'contrast',
    keywords: ['color', 'difference', 'design'],
  },
  {
    name: 'cookie',
    keywords: ['food', 'snack', 'sweet'],
  },
  {
    name: 'copy',
    keywords: ['duplicate', 'document', 'clipboard'],
  },
  {
    name: 'copyleft',
    keywords: ['license', 'copyright', 'legal'],
  },
  {
    name: 'copyright',
    keywords: ['license', 'legal', 'intellectual'],
  },
  {
    name: 'corner-down-left',
    keywords: ['arrow', 'corner', 'down'],
  },
  {
    name: 'corner-down-right',
    keywords: ['arrow', 'corner', 'down'],
  },
  {
    name: 'corner-left-down',
    keywords: ['arrow', 'corner', 'left'],
  },
  {
    name: 'corner-left-up',
    keywords: ['arrow', 'corner', 'left'],
  },
  {
    name: 'corner-right-down',
    keywords: ['arrow', 'corner', 'right'],
  },
  {
    name: 'corner-right-up',
    keywords: ['arrow', 'corner', 'right'],
  },
  {
    name: 'corner-up-left',
    keywords: ['arrow', 'corner', 'up'],
  },
  {
    name: 'corner-up-right',
    keywords: ['arrow', 'corner', 'up'],
  },
  {
    name: 'croissant',
    keywords: ['food', 'bread', 'breakfast'],
  },
  {
    name: 'crop',
    keywords: ['image', 'edit', 'resize'],
  },
  {
    name: 'cross',
    keywords: ['x', 'close', 'remove'],
  },
  {
    name: 'crosshair',
    keywords: ['target', 'aim', 'focus'],
  },
  {
    name: 'crown',
    keywords: ['king', 'queen', 'royal'],
  },
  {
    name: 'cup-soda',
    keywords: ['drink', 'beverage', 'soda'],
  },
  {
    name: 'currency',
    keywords: ['money', 'finance', 'exchange'],
  },
  {
    name: 'delete',
    keywords: ['remove', 'trash', 'bin'],
  },
  {
    name: 'diamond',
    keywords: ['gem', 'jewel', 'precious'],
  },
  {
    name: 'dice-1',
    keywords: ['game', 'random', 'number'],
  },
  {
    name: 'dice-2',
    keywords: ['game', 'random', 'number'],
  },
  {
    name: 'dice-3',
    keywords: ['game', 'random', 'number'],
  },
  {
    name: 'dice-4',
    keywords: ['game', 'random', 'number'],
  },
  {
    name: 'dice-5',
    keywords: ['game', 'random', 'number'],
  },
  {
    name: 'dice-6',
    keywords: ['game', 'random', 'number'],
  },
  {
    name: 'disc',
    keywords: ['music', 'cd', 'media'],
  },
  {
    name: 'divide',
    keywords: ['math', 'arithmetic', 'split'],
  },
  {
    name: 'dna',
    keywords: ['science', 'biology', 'gene'],
  },
  {
    name: 'dog',
    keywords: ['animal', 'pet', 'canine'],
  },
  {
    name: 'dollar-sign',
    keywords: ['money', 'finance', 'currency'],
  },
  {
    name: 'dribbble',
    keywords: ['basketball', 'social', 'network'],
  },
  {
    name: 'droplets',
    keywords: ['water', 'liquid', 'drop'],
  },
  {
    name: 'drumstick',
    keywords: ['food', 'chicken', 'meat'],
  },
  {
    name: 'egg',
    keywords: ['food', 'breakfast', 'protein'],
  },
  {
    name: 'egg-fried',
    keywords: ['food', 'breakfast', 'protein'],
  },
  {
    name: 'equal',
    keywords: ['math', 'arithmetic', 'equals'],
  },
  {
    name: 'equal-not',
    keywords: ['math', 'arithmetic', 'not'],
  },
  {
    name: 'eraser',
    keywords: ['remove', 'edit', 'delete'],
  },
  {
    name: 'euro',
    keywords: ['money', 'finance', 'currency'],
  },
  {
    name: 'expand',
    keywords: ['resize', 'grow', 'fullscreen'],
  },
  {
    name: 'facebook',
    keywords: ['social', 'network', 'media'],
  },
  {
    name: 'fast-forward',
    keywords: ['media', 'skip', 'next'],
  },
  {
    name: 'figma',
    keywords: ['design', 'tool', 'ui'],
  },
  {
    name: 'file-audio',
    keywords: ['document', 'audio', 'music'],
  },
  {
    name: 'file-check',
    keywords: ['document', 'check', 'done'],
  },
  {
    name: 'file-code',
    keywords: ['document', 'code', 'program'],
  },
  {
    name: 'file-diff',
    keywords: ['document', 'difference', 'compare'],
  },
  {
    name: 'file-image',
    keywords: ['document', 'image', 'photo'],
  },
  {
    name: 'file-minus',
    keywords: ['document', 'remove', 'delete'],
  },
  {
    name: 'file-plus',
    keywords: ['document', 'add', 'new'],
  },
  {
    name: 'file-search',
    keywords: ['document', 'search', 'find'],
  },
  {
    name: 'file-text',
    keywords: ['document', 'text', 'write'],
  },
  {
    name: 'file-x',
    keywords: ['document', 'remove', 'delete'],
  },
  {
    name: 'fingerprint',
    keywords: ['identity', 'security', 'touch'],
  },
  {
    name: 'flame',
    keywords: ['fire', 'hot', 'burn'],
  },
  {
    name: 'flashlight',
    keywords: ['light', 'torch', 'lamp'],
  },
  {
    name: 'flip-horizontal',
    keywords: ['mirror', 'horizontal', 'flip'],
  },
  {
    name: 'flip-vertical',
    keywords: ['mirror', 'vertical', 'flip'],
  },
  {
    name: 'focus',
    keywords: ['target', 'aim', 'center'],
  },
  {
    name: 'folder',
    keywords: ['directory', 'file', 'storage'],
  },
  {
    name: 'folder-minus',
    keywords: ['directory', 'file', 'remove'],
  },
  {
    name: 'folder-open',
    keywords: ['directory', 'file', 'open'],
  },
  {
    name: 'folder-plus',
    keywords: ['directory', 'file', 'add'],
  },
  {
    name: 'forward',
    keywords: ['arrow', 'right', 'next'],
  },
  {
    name: 'framer',
    keywords: ['design', 'tool', 'ui'],
  },
  {
    name: 'gauge',
    keywords: ['meter', 'speed', 'dashboard'],
  },
  {
    name: 'gem',
    keywords: ['diamond', 'jewel', 'precious'],
  },
  {
    name: 'ghost',
    keywords: ['spirit', 'halloween', 'scary'],
  },
  {
    name: 'git-branch',
    keywords: ['code', 'version', 'branch'],
  },
  {
    name: 'git-compare',
    keywords: ['code', 'version', 'compare'],
  },
  {
    name: 'git-fork',
    keywords: ['code', 'version', 'fork'],
  },
  {
    name: 'git-merge',
    keywords: ['code', 'version', 'merge'],
  },
  {
    name: 'git-pull-request',
    keywords: ['code', 'version', 'pull'],
  },
  {
    name: 'github',
    keywords: ['code', 'version', 'repository'],
  },
  {
    name: 'gitlab',
    keywords: ['code', 'version', 'repository'],
  },
  {
    name: 'grape',
    keywords: ['fruit', 'food', 'purple'],
  },
  {
    name: 'grip-horizontal',
    keywords: ['move', 'drag', 'handle'],
  },
  {
    name: 'grip-vertical',
    keywords: ['move', 'drag', 'handle'],
  },
  {
    name: 'hammer',
    keywords: ['tool', 'build', 'fix'],
  },
  {
    name: 'hand-metal',
    keywords: ['gesture', 'rock', 'music'],
  },
  {
    name: 'hard-drive',
    keywords: ['storage', 'disk', 'computer'],
  },
  {
    name: 'hash',
    keywords: ['number', 'symbol', 'hashtag'],
  },
  {
    name: 'haze',
    keywords: ['weather', 'fog', 'cloud'],
  },
  {
    name: 'headphones',
    keywords: ['audio', 'music', 'sound'],
  },
  {
    name: 'heart-crack',
    keywords: ['love', 'break', 'sad'],
  },
  {
    name: 'heart-handshake',
    keywords: ['love', 'handshake', 'agreement'],
  },
  {
    name: 'heart-off',
    keywords: ['love', 'off', 'remove'],
  },
  {
    name: 'heart-pulse',
    keywords: ['love', 'heartbeat', 'health'],
  },
  {
    name: 'hexagon',
    keywords: ['shape', 'geometry', 'polygon'],
  },
  {
    name: 'highlighter',
    keywords: ['edit', 'draw', 'highlight'],
  },
  {
    name: 'history',
    keywords: ['time', 'past', 'clock'],
  },
  {
    name: 'hotel',
    keywords: ['building', 'travel', 'stay'],
  },
  {
    name: 'hourglass',
    keywords: ['time', 'wait', 'sand'],
  },
  {
    name: 'ice-cream-cone',
    keywords: ['dessert', 'food', 'sweet'],
  },
  {
    name: 'import',
    keywords: ['arrow', 'in', 'download'],
  },
  {
    name: 'inbox',
    keywords: ['mail', 'email', 'message'],
  },
  {
    name: 'indian-rupee',
    keywords: ['money', 'finance', 'currency'],
  },
  {
    name: 'infinity',
    keywords: ['forever', 'endless', 'loop'],
  },
  {
    name: 'instagram',
    keywords: ['social', 'media', 'photo'],
  },
  {
    name: 'italic',
    keywords: ['text', 'format', 'style'],
  },
  {
    name: 'japanese-yen',
    keywords: ['money', 'finance', 'currency'],
  },
  {
    name: 'joystick',
    keywords: ['game', 'controller', 'play'],
  },
  {
    name: 'key',
    keywords: ['lock', 'security', 'password'],
  },
  {
    name: 'keyboard',
    keywords: ['type', 'input', 'computer'],
  },
  {
    name: 'lamp',
    keywords: ['light', 'bulb', 'desk'],
  },
  {
    name: 'laptop',
    keywords: ['computer', 'device', 'portable'],
  },
  {
    name: 'lasso',
    keywords: ['select', 'tool', 'draw'],
  },
  {
    name: 'layers',
    keywords: ['stack', 'design', 'arrange'],
  },
  {
    name: 'library',
    keywords: ['books', 'read', 'education'],
  },
  {
    name: 'life-buoy',
    keywords: ['help', 'support', 'rescue'],
  },
  {
    name: 'link-2',
    keywords: ['url', 'web', 'chain'],
  },
  {
    name: 'link-2-off',
    keywords: ['url', 'web', 'chain'],
  },
  {
    name: 'linkedin',
    keywords: ['social', 'media', 'network'],
  },
  {
    name: 'list-checks',
    keywords: ['items', 'bullets', 'check'],
  },
  {
    name: 'list-end',
    keywords: ['items', 'bullets', 'end'],
  },
  {
    name: 'list-minus',
    keywords: ['items', 'bullets', 'remove'],
  },
  {
    name: 'list-music',
    keywords: ['items', 'bullets', 'music'],
  },
  {
    name: 'list-ordered',
    keywords: ['items', 'bullets', 'order'],
  },
  {
    name: 'list-plus',
    keywords: ['items', 'bullets', 'add'],
  },
  {
    name: 'list-start',
    keywords: ['items', 'bullets', 'start'],
  },
  {
    name: 'list-video',
    keywords: ['items', 'bullets', 'video'],
  },
  {
    name: 'list-x',
    keywords: ['items', 'bullets', 'remove'],
  },
  {
    name: 'loader',
    keywords: ['loading', 'progress', 'spinner'],
  },
  {
    name: 'loader-circle',
    keywords: ['loading', 'progress', 'spinner'],
  },
  {
    name: 'locate',
    keywords: ['location', 'gps', 'map'],
  },
  {
    name: 'log-in',
    keywords: ['sign', 'enter', 'access'],
  },
  {
    name: 'log-out',
    keywords: ['sign', 'exit', 'leave'],
  },
  {
    name: 'mail-check',
    keywords: ['email', 'message', 'check'],
  },
  {
    name: 'mail-minus',
    keywords: ['email', 'message', 'remove'],
  },
  {
    name: 'mail-open',
    keywords: ['email', 'message', 'envelope'],
  },
  {
    name: 'mail-plus',
    keywords: ['email', 'message', 'add'],
  },
  {
    name: 'mail-x',
    keywords: ['email', 'message', 'remove'],
  },
  {
    name: 'maximize',
    keywords: ['resize', 'grow', 'fullscreen'],
  },
  {
    name: 'megaphone',
    keywords: ['announcement', 'loud', 'sound'],
  },
  {
    name: 'message-square',
    keywords: ['chat', 'talk', 'bubble'],
  },
  {
    name: 'microscope',
    keywords: ['science', 'lab', 'biology'],
  },
  {
    name: 'milk',
    keywords: ['drink', 'dairy', 'food'],
  },
  {
    name: 'minimize',
    keywords: ['resize', 'shrink', 'window'],
  },
  {
    name: 'monitor',
    keywords: ['screen', 'display', 'computer'],
  },
  {
    name: 'mouse-pointer',
    keywords: ['cursor', 'click', 'select'],
  },
  {
    name: 'move',
    keywords: ['drag', 'arrow', 'direction'],
  },
  {
    name: 'navigation',
    keywords: ['arrow', 'direction', 'map'],
  },
  {
    name: 'navigation-2',
    keywords: ['arrow', 'direction', 'map'],
  },
  {
    name: 'octagon',
    keywords: ['shape', 'geometry', 'polygon'],
  },
  {
    name: 'option',
    keywords: ['choice', 'select', 'settings'],
  },
  {
    name: 'package',
    keywords: ['box', 'shipping', 'parcel'],
  },
  {
    name: 'paint-bucket',
    keywords: ['paint', 'color', 'fill'],
  },
  {
    name: 'paintbrush',
    keywords: ['paint', 'art', 'draw'],
  },
  {
    name: 'pen-tool',
    keywords: ['draw', 'design', 'vector'],
  },
  {
    name: 'percent',
    keywords: ['math', 'discount', 'sale'],
  },
  {
    name: 'phone-call',
    keywords: ['call', 'mobile', 'device'],
  },
  {
    name: 'phone-forwarded',
    keywords: ['call', 'mobile', 'forward'],
  },
  {
    name: 'phone-incoming',
    keywords: ['call', 'mobile', 'incoming'],
  },
  {
    name: 'phone-missed',
    keywords: ['call', 'mobile', 'missed'],
  },
  {
    name: 'phone-off',
    keywords: ['call', 'mobile', 'off'],
  },
  {
    name: 'phone-outgoing',
    keywords: ['call', 'mobile', 'outgoing'],
  },
  {
    name: 'piggy-bank',
    keywords: ['money', 'save', 'finance'],
  },
  {
    name: 'pin',
    keywords: ['location', 'map', 'place'],
  },
  {
    name: 'pizza',
    keywords: ['food', 'cheese', 'slice'],
  },
  {
    name: 'plane',
    keywords: ['flight', 'travel', 'airplane'],
  },
  {
    name: 'plug',
    keywords: ['power', 'electric', 'connect'],
  },
  {
    name: 'pocket',
    keywords: ['save', 'app', 'read'],
  },
  {
    name: 'pointer',
    keywords: ['cursor', 'click', 'select'],
  },
  {
    name: 'pound-sterling',
    keywords: ['money', 'finance', 'currency'],
  },
  {
    name: 'power',
    keywords: ['on', 'off', 'energy'],
  },
  {
    name: 'printer',
    keywords: ['print', 'document', 'paper'],
  },
  {
    name: 'puzzle',
    keywords: ['game', 'piece', 'problem'],
  },
  {
    name: 'qr-code',
    keywords: ['scan', 'code', 'barcode'],
  },
  {
    name: 'quote',
    keywords: ['text', 'citation', 'speech'],
  },
  {
    name: 'radio',
    keywords: ['music', 'audio', 'broadcast'],
  },
  {
    name: 'rainbow',
    keywords: ['color', 'weather', 'nature'],
  },
  {
    name: 'receipt',
    keywords: ['bill', 'payment', 'finance'],
  },
  {
    name: 'reply',
    keywords: ['answer', 'mail', 'message'],
  },
  {
    name: 'rewind',
    keywords: ['media', 'back', 'previous'],
  },
  {
    name: 'rss',
    keywords: ['feed', 'news', 'web'],
  },
  {
    name: 'ruler',
    keywords: ['measure', 'length', 'tool'],
  },
  {
    name: 'save',
    keywords: ['disk', 'floppy', 'document'],
  },
  {
    name: 'scissors',
    keywords: ['cut', 'tool', 'edit'],
  },
  {
    name: 'send',
    keywords: ['mail', 'message', 'arrow'],
  },
  {
    name: 'share',
    keywords: ['send', 'forward', 'arrow'],
  },
  {
    name: 'share-2',
    keywords: ['send', 'forward', 'arrow'],
  },
  {
    name: 'shield-off',
    keywords: ['security', 'protection', 'off'],
  },
  {
    name: 'skip-back',
    keywords: ['media', 'previous', 'rewind'],
  },
  {
    name: 'skip-forward',
    keywords: ['media', 'next', 'forward'],
  },
  {
    name: 'slash',
    keywords: ['divide', 'symbol', 'cut'],
  },
  {
    name: 'smartphone',
    keywords: ['mobile', 'device', 'phone'],
  },
  {
    name: 'snowflake',
    keywords: ['weather', 'cold', 'winter'],
  },
  {
    name: 'speaker',
    keywords: ['audio', 'sound', 'music'],
  },
  {
    name: 'stethoscope',
    keywords: ['doctor', 'health', 'medical'],
  },
  {
    name: 'tablet',
    keywords: ['device', 'mobile', 'screen'],
  },
  {
    name: 'ticket',
    keywords: ['event', 'admission', 'pass'],
  },
  {
    name: 'timer',
    keywords: ['clock', 'time', 'countdown'],
  },
  {
    name: 'toggle-left',
    keywords: ['switch', 'on', 'off'],
  },
  {
    name: 'toggle-right',
    keywords: ['switch', 'on', 'off'],
  },
  {
    name: 'triangle',
    keywords: ['shape', 'geometry', 'polygon'],
  },
  {
    name: 'underline',
    keywords: ['text', 'format', 'style'],
  },
  {
    name: 'cloud-upload',
    keywords: ['send', 'cloud', 'arrow'],
  },
  {
    name: 'user-check',
    keywords: ['person', 'account', 'check'],
  },
  {
    name: 'user-minus',
    keywords: ['person', 'account', 'remove'],
  },
  {
    name: 'user-plus',
    keywords: ['person', 'account', 'add'],
  },
  {
    name: 'user-x',
    keywords: ['person', 'account', 'remove'],
  },
  {
    name: 'video',
    keywords: ['media', 'movie', 'film'],
  },
  {
    name: 'video-off',
    keywords: ['media', 'movie', 'off'],
  },
  {
    name: 'voicemail',
    keywords: ['phone', 'message', 'audio'],
  },
  {
    name: 'volume-1',
    keywords: ['sound', 'audio', 'speaker'],
  },
  {
    name: 'wifi-off',
    keywords: ['internet', 'wireless', 'off'],
  },
  {
    name: 'wind',
    keywords: ['weather', 'air', 'nature'],
  },
  {
    name: 'circle-x',
    keywords: ['close', 'remove', 'delete'],
  },
  {
    name: 'octagon-x',
    keywords: ['close', 'remove', 'delete'],
  },
  {
    name: 'square-x',
    keywords: ['close', 'remove', 'delete'],
  },
  {
    name: 'youtube',
    keywords: ['video', 'media', 'play'],
  },
  {
    name: 'zap-off',
    keywords: ['lightning', 'energy', 'off'],
  },
  {
    name: 'zoom-in',
    keywords: ['magnify', 'search', 'in'],
  },
  {
    name: 'zoom-out',
    keywords: ['magnify', 'search', 'out'],
  },
]
